import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { SelfHostedAccesses } from "./accesses.ts";
import { SelfHostedComponents } from "./components.ts";

const SelfHostedFilters = {
  environment: { keys: ["id"] },
  host: {
    keys: ["fingerprint", "hostname", "id", "public-ip"],
    labeler: { "public-ip": "Public IP" },
  },
  sudo: { keys: "boolean" },
} as const satisfies AnyFilterSchema;

export type SelfHostedFilters = typeof SelfHostedFilters;

export const SelfHostedRegistration = Registration({
  accesses: SelfHostedAccesses,
  category: "resource",
  components: SelfHostedComponents,
  docs: { install: "ssh/self-hosted" },
  filters: SelfHostedFilters,
  flag: "self-hosted-integration",
  itemKind: "environment",
  label: "Self-hosted",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Black_computer_icon.png/960px-Black_computer_icon.png",
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("self-hosted", SelfHostedRegistration);
